import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params) => {
    return network.post('api/bo/saveCustomCluster', params).then((response) => {
        return response.data;
    });
};

export const useMutationSaveSearchWord = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    customerId: number | undefined;
    paFileMetaDataIds: number[];
    projectId: number | undefined;
    query: string | undefined;
}
